/**
 * Shared shape for the contact-form action result.
 *
 * Lives outside `actions.ts` on purpose: a `'use server'` module may only
 * export async functions, so a plain constant exported from there arrives
 * as `undefined` on the client.
 */
export type LeadState = {
  status: 'idle' | 'success' | 'error';
  message: string;
  /** Field-level messages keyed by input name. */
  errors: Partial<Record<'name' | 'phone' | 'topic' | 'brief', string>>;
};

export const initialLeadState: LeadState = {
  status: 'idle',
  message: '',
  errors: {},
};
